import React, { useState } from "react";
import PropTypes from "prop-types";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import createfolderlogo from "../../../Assets/createfolderlogo.svg";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import Delete from "../../../Assets/Delete.svg";
import disabledelete from "../../../Assets/disabledelete.png";
import publicLock from "../../../Assets/publicLock.svg";
import privateLock from "../../../Assets/privateLock.svg";
import privatelockdisabled from "../../../Assets/privatelockdisabled.svg";
import decisionMakerImage from "../../../Assets/Cloudfigma.svg";
import publiclockdiabled from "../../../Assets/publiclockdiabled.svg";
import activeSaleforceLogo from "../../../Assets/activeSaleforceLogo.svg";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Modal,
  Button,
  Box,
  RadioGroup,
  Radio,
  FormControlLabel,
  InputBase,
} from "@mui/material";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
import Tooltip from "@mui/material/Tooltip";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Loader from "../../Loader/Loader";
import { toast } from "react-toastify";
import moment from "moment";
import {
  APIUrlOne,
  APIUrlThree,
  APIUrlToken,
  APIUrlTwo,
  GetOktaAuthData,
  GetUserId,
  logEvent,
} from "../../../Utils/Utils";
import IndustryDropdown from "../../AiLeads/IndustrySectorDropdown/Index";
import ContactDetailList from "../../AiLeads/ContactDetailList/ContactDetailList";
import RightSidebar from "../../RightSiderbar/RightSiderbar";
import redSearchicon from "../../../Assets/searchiconred.svg";
import CloseIcon from "@mui/icons-material/Close";

import {
  AI_PROFILE_FORM_TABLE,
  AI_PROSPECT_PROFILE,
  COMPANY_PROFILE_SCREEN,
} from "../../../Utils/Constants";
import MFavPeopleInnerTable from "./MFavPeopleInnerTable";
function Row({
  key,
  row,
  ExpandHandler,
  expandHandlerAccept,
  setPageInner,
  pageInner,
  openRowId,
  onLoadApi,
  setHasMoreInner,
  setopenRowId,
  totalPages,
  rowsSelect,
  setRowsSelect,
  organizationList,
  setOrganizationList,
  handleRowSelect,
  setoOenCreateListmdl,
  setOpenCreateMdl,
  setSelectedOption,
  setUpdatelist,
  setListName,
  setUpdatedId,
  setSelectedListId,
  setOpenDeleteModal,
  innerDataNew,
  setInnerDataNew,
  handleRowSelectList,
  selectedOrganizationList,
  selectedOrganizationData,
  setSelectedOrganizationData,
  disableOrganizationList,
  disableOrganizationData,
  userId,
  isMobile,
  isTabPortrait,
}) {
  const navigate = useNavigate();
  const loggedInUserId = GetUserId();

  // const [innerTableData, setInnerTAbleData] = React.useState([]);
  const [sortField, setSortField] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = useState();
  const [sortOrder, setSortOrder] = React.useState(null);
  const [openSidebar, setOpenSidebar] = React.useState(false);
  const [userDetails, setUserDeatils] = React.useState();
  const [dataShortestPath, setDataShortestPath] = React.useState();

  const handleAllSelectCollapsible = () => {
    if (rowsSelect) {
      const newList = innerDataNew?.map((info) => ({
        ...info,
        organizationInfo: row,
      }));
      setSelectedOrganizationData(newList);
    } else {
      setSelectedOrganizationData([]);
    }
  };

  const onExpand = (event) => {
    setLoading(true);
    setOpen(true);
    onLoadApi(event)
      .then((e) => {
        const childData = e;
        getStrength(childData, true);
      })
      .catch(() => {
        setLoading(false);
        setOpen(false);
      });
  };

  const ExpandHandlerChild = (event) => {
    setLoading(true);
    ExpandHandler(event)
      .then((e) => {
        const childData = e;
        getStrength(childData, false);
        setLoading(false);
        if (e?.status === 200) {
          const innerdata = e?.data?.data;
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  React.useEffect(() => {
    if (expandHandlerAccept?.length > 0) {
      setInnerDataNew([...expandHandlerAccept]);
    }
  }, [expandHandlerAccept]);

  const getStrength = async (childData, isExpand) => {
    if (!childData?.length) {
      setLoading(false);
      return;
    }
    setLoading(true);

    const tuples = childData?.map((item) => ({
      // items: [Number(loggedInUserId), item.person_id],
      items: [
        loggedInUserId?.toString(),
        item.people_details?.person_id?.toString(),
      ],
    }));
    const data = { tuples };
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      data: data,
      url: `${APIUrlTwo()}/v1/conn_strength`,
    };

    try {
      const response = await axios(options);
      const strengthData = response?.data;

      const updatedData = childData?.map((item, index) => ({
        ...item,
        strengthData: strengthData[index],
      }));
      if (isExpand === true) {
        setInnerDataNew([...updatedData]);
      } else {
        setInnerDataNew([...innerDataNew, ...updatedData]);
      }

      if (open) {
      } else {
        setOpen(!open);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 0);
      setTimeout(() => {
        setHasMoreInner(true);
      }, 1000);
    }
  };
  const clickHandler = (event) => {
    navigate(`/companyprofilescreen/${event?.org_id}/0`);
  };

  React.useEffect(() => {
    if (
      innerDataNew?.length >= 20 &&
      row.User_favourite_list.id === openRowId &&
      pageInner > 1 &&
      pageInner <= Math.ceil(pages)
    ) {
      setHasMoreInner(false);
      ExpandHandlerChild(openRowId);
    }
  }, [pageInner]);

  const pages = row.fav_people_count / 20;

  const closeExpandHandler = () => {
    setInnerDataNew([]);
    setInnerDataNew("");
    setInnerDataNew([]);
    setOpen(false);
    setopenRowId("");
  };

  React.useEffect(() => {
    handleAllSelectCollapsible();
  }, [rowsSelect]);
  const ref = React.useRef(null);
  const isBranchLocationsDisabled = true;

  const loadMore = () => {
    setLoading(true);
    setPageInner((prevPageInner) => prevPageInner + 1);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };
  const handleSort = (field) => {
    let newSortOrder;
    if (sortField === field) {
      newSortOrder = sortOrder === "asc" ? "desc" : "asc";
    } else {
      newSortOrder = "asc";
    }
    setSortOrder(newSortOrder);
    setSortField(field);

    const employeeOrder = [
      "1-10",
      "11-50",
      "51-100",
      "101-250",
      "251-500",
      "501-1000",
      "1K-5K",
      "5K-10K",
      "10K+",
    ];

    const revenueOrder = [
      "$0-$1m",
      "$0-$1M",
      "$1m-$10m",
      "$1M-$10M",
      "$10m-$50m",
      "$10M-$50M",
      "$50m-$100m",
      "$50M-$100M",
      ,
      "$100m-$500m",
      "$100M-$500M",
      "$500m-$1b",
      "$500M-$1B",
      "$1b-$10b",
      "$1B-$10B",
      "$10b+",
      "$10B+",
    ];

    const getOrderIndex = (value, orderArray) => {
      const index = orderArray.indexOf(value);
      return index !== -1 ? index : orderArray.length;
    };

    const sortedData = [...organizationList].sort((a, b) => {
      let aValue = field.includes(".")
        ? field.split(".").reduce((acc, key) => acc?.[key], a)
        : a[field];
      let bValue = field.includes(".")
        ? field.split(".").reduce((acc, key) => acc?.[key], b)
        : b[field];

      const isEmpty = (val) => val === null || val === "" || val === "-";
      const aIsEmpty = isEmpty(aValue);
      const bIsEmpty = isEmpty(bValue);

      if (aIsEmpty && !bIsEmpty) return 1;
      if (!aIsEmpty && bIsEmpty) return -1;
      if (aIsEmpty && bIsEmpty) return 0;

      if (field === "updated_at") {
        aValue = new Date(aValue);
        bValue = new Date(bValue);
      }

      if (field === "num_employees") {
        return newSortOrder === "asc"
          ? getOrderIndex(aValue, employeeOrder) -
              getOrderIndex(bValue, employeeOrder)
          : getOrderIndex(bValue, employeeOrder) -
              getOrderIndex(aValue, employeeOrder);
      }

      if (field === "revenue_range") {
        return newSortOrder === "asc"
          ? getOrderIndex(aValue, revenueOrder) -
              getOrderIndex(bValue, revenueOrder)
          : getOrderIndex(bValue, revenueOrder) -
              getOrderIndex(aValue, revenueOrder);
      }

      if (typeof aValue === "number" && typeof bValue === "number") {
        return newSortOrder === "asc" ? aValue - bValue : bValue - aValue;
      }

      if (typeof aValue === "string" && typeof bValue === "string") {
        return newSortOrder === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      if (aValue instanceof Date && bValue instanceof Date) {
        return newSortOrder === "asc" ? aValue - bValue : bValue - aValue;
      }

      return 0;
    });

    setOrganizationList(sortedData);
  };
  const isDefault = row?.is_default;

  const handleOpenListMdlUpdate = (name, id) => {
    setoOenCreateListmdl(true);
    setOpenCreateMdl(false);
    setSelectedOption("");
    setListName(name);
    setUpdatelist(true);
    setUpdatedId(id);
  };

  const handleOpenDeleteModal = (id) => {
    setSelectedListId(id);
    setOpenDeleteModal(true);
  };

  const handlePrivacyClick = (id) => {
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/isprivate_favourite_list?id=${id}`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          toast.success(e?.data?.message);
        }
      })
      .catch((err) => {
        console.error("Error enriching prospect", err);
        setLoading(false);
      });
  };
  const handleRightsidebar = (event) => {
    logEvent("shortest-path", "JOI");
    const data = {};
    data.source_uid = Number(userId);
    data.target_uid = Number(event?.people_details?.person_id);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      data: data,
      url: `${APIUrlTwo()}/v1/shortest-path`,
    };
    axios(option)
      .then((response) => {
        if (response?.status === 200) {
          const data = Object.values(response.data);
          setDataShortestPath(data);
          setOpenSidebar(true);
          setUserDeatils(event);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };
  const [openTableDrawer, setOpenTableDrawer] = useState();

  return (
    <React.Fragment key={key}>
      {/* {loading ? <Loader /> : null} */}
      {/* mobile code  */}
      {isMobile ? (
        <TableRow
          sx={{ "& > *": { borderBottom: "unset" } }}
          // style={{ cursor: "pointer" }}
        >
          <>
            <TableCell align="center" style={{ padding: "5px" }}>
              <h3 className="employee-size-table">
                {row?.User_favourite_list?.name
                  ? row?.User_favourite_list?.name
                  : "-"}
              </h3>
              <h3 className="employee-size-table-date-mobile">
                {row?.User_favourite_list?.created_date
                  ? moment(row?.User_favourite_list?.created_date).format(
                      "DD MMM YYYY",
                    )
                  : "-"}
              </h3>
            </TableCell>

            <TableCell align="left" style={{ padding: "5px" }}>
              <div
                className="privacy-status-tr"
                style={{
                  color: "grey",
                  cursor: "not-allowed",
                }}
              >
                <h3 className="annual-revenue-table">
                  {row?.User_favourite_list?.is_private ? "Private" : "Public"}
                </h3>
                <img
                  style={{
                    color: "grey",
                    cursor: "not-allowed",
                  }}
                  src={
                    row?.User_favourite_list?.is_private
                      ? privateLock
                      : publiclockdiabled
                  }
                  alt="My Lists"
                />
              </div>
            </TableCell>
            <TableCell align="left" style={{ padding: "5px" }}>
              <h3 className="employee-size-table-mobile">
                {row?.user?.first_name ? row?.user?.first_name : "-"}{" "}
                {row?.user?.last_name ? row?.user?.last_name : "-"}
              </h3>
              <h3 className="employee-size-table-mobile">
                {row?.fav_people_count ? row?.fav_people_count : "-"}
              </h3>
              <TableCell align="right" className="three-dot-cell">
                {Number(row?.user?.person_id) === Number(userId) ? (
                  <span
                    className="threeDotIcon-table-profile"
                    onClick={() =>
                      !isDefault &&
                      handleOpenDeleteModal(row?.User_favourite_list?.id)
                    }
                  >
                    <img src={isDefault ? disabledelete : Delete} alt="" />
                  </span>
                ) : (
                  <span
                    className="threeDotIcon-table-profile"
                    style={{
                      color: "grey",
                      cursor: "not-allowed",
                    }}
                  >
                    <img src={disabledelete} alt="" />
                  </span>
                )}
                {Number(row?.user?.person_id) === Number(userId) ? (
                  <span
                    className="threeDotIcon-table-profile"
                    onClick={() =>
                      !isDefault &&
                      handleOpenListMdlUpdate(
                        row?.User_favourite_list?.name,
                        row?.User_favourite_list?.id,
                      )
                    }
                    style={{
                      color: isDefault ? "grey" : "",
                      cursor: isDefault ? "not-allowed" : "pointer",
                    }}
                  >
                    <DriveFileRenameOutlineIcon />
                  </span>
                ) : (
                  <span
                    className="threeDotIcon-table-profile"
                    style={{
                      color: "grey",
                      cursor: "not-allowed",
                    }}
                  >
                    <DriveFileRenameOutlineIcon />
                  </span>
                )}

                <span
                  className=""
                  // onClick={() => handleExpandRecords(row?.id)}
                >
                  <Tooltip title={open ? "Collapse" : "Expand"}>
                    {open ? (
                      <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => closeExpandHandler()}
                        className="threeDotIcon-table-profile"
                      >
                        <RemoveRoundedIcon className="icon-collapse-table" />
                      </IconButton>
                    ) : (
                      <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => {
                          setOpenTableDrawer(row);
                          setInnerDataNew([]);
                          setHasMoreInner(false);
                          setTimeout(() => {
                            if (openRowId !== row?.User_favourite_list?.id) {
                              setLoading(true);
                              setPageInner(1);
                              setopenRowId(row?.User_favourite_list?.id);
                              onExpand(row?.User_favourite_list?.id);
                            }
                          }, 0);
                        }}
                        className="threeDotIcon-table-profile"
                      >
                        <AddIcon className="icon-collapse-table" />
                      </IconButton>
                    )}
                  </Tooltip>
                </span>
              </TableCell>
            </TableCell>
          </>
        </TableRow>
      ) : // tab portrait code
      isTabPortrait ? (
        <TableRow
          sx={{ "& > *": { borderBottom: "unset" } }}
          // style={{ cursor: "pointer" }}
        >
          <>
            <TableCell align="center" style={{ padding: "5px" }}>
              <h3 className="employee-size-table">
                {row?.User_favourite_list?.name
                  ? row?.User_favourite_list?.name
                  : "-"}
              </h3>
              <h3 className="employee-size-table-date-mobile">
                {row?.User_favourite_list?.created_date
                  ? moment(row?.User_favourite_list?.created_date).format(
                      "DD MMM YYYY",
                    )
                  : "-"}
              </h3>
            </TableCell>

            <TableCell align="left" style={{ padding: "5px" }}>
              <div
                className="privacy-status-tr"
                style={{
                  color: "grey",
                  cursor: "not-allowed",
                }}
              >
                <h3 className="annual-revenue-table">
                  {row?.User_favourite_list?.is_private ? "Private" : "Public"}
                </h3>
                <img
                  style={{
                    color: "grey",
                    cursor: "not-allowed",
                  }}
                  src={
                    row?.User_favourite_list?.is_private
                      ? privateLock
                      : publiclockdiabled
                  }
                  alt="My Lists"
                />
              </div>
            </TableCell>
            <TableCell align="left" style={{ padding: "5px" }}>
              <h3 className="employee-size-table-mobile">
                {row?.user?.first_name ? row?.user?.first_name : "-"}{" "}
                {row?.user?.last_name ? row?.user?.last_name : "-"}
              </h3>
              <h3 className="employee-size-table-mobile">
                {row?.fav_people_count ? row?.fav_people_count : "-"}
              </h3>
              <TableCell align="right" className="three-dot-cell">
                {Number(row?.user?.person_id) === Number(userId) ? (
                  <span
                    className="threeDotIcon-table-profile"
                    onClick={() =>
                      !isDefault &&
                      handleOpenDeleteModal(row?.User_favourite_list?.id)
                    }
                  >
                    <img src={isDefault ? disabledelete : Delete} alt="" />
                  </span>
                ) : (
                  <span
                    className="threeDotIcon-table-profile"
                    style={{
                      color: "grey",
                      cursor: "not-allowed",
                    }}
                  >
                    <img src={disabledelete} alt="" />
                  </span>
                )}
                {Number(row?.user?.person_id) === Number(userId) ? (
                  <span
                    className="threeDotIcon-table-profile"
                    onClick={() =>
                      !isDefault &&
                      handleOpenListMdlUpdate(
                        row?.User_favourite_list?.name,
                        row?.User_favourite_list?.id,
                      )
                    }
                    style={{
                      color: isDefault ? "grey" : "",
                      cursor: isDefault ? "not-allowed" : "pointer",
                    }}
                  >
                    <DriveFileRenameOutlineIcon />
                  </span>
                ) : (
                  <span
                    className="threeDotIcon-table-profile"
                    style={{
                      color: "grey",
                      cursor: "not-allowed",
                    }}
                  >
                    <DriveFileRenameOutlineIcon />
                  </span>
                )}

                <span
                  className=""
                  // onClick={() => handleExpandRecords(row?.id)}
                >
                  <Tooltip title={open ? "Collapse" : "Expand"}>
                    {open ? (
                      <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => closeExpandHandler()}
                        className="threeDotIcon-table-profile"
                      >
                        <RemoveRoundedIcon className="icon-collapse-table" />
                      </IconButton>
                    ) : (
                      <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => {
                          setOpenTableDrawer(row);
                          setInnerDataNew([]);
                          setHasMoreInner(false);
                          setTimeout(() => {
                            if (openRowId !== row?.User_favourite_list?.id) {
                              setLoading(true);
                              setPageInner(1);
                              setopenRowId(row?.User_favourite_list?.id);
                              onExpand(row?.User_favourite_list?.id);
                            }
                          }, 0);
                        }}
                        className="threeDotIcon-table-profile"
                      >
                        <AddIcon className="icon-collapse-table" />
                      </IconButton>
                    )}
                  </Tooltip>
                </span>
              </TableCell>
            </TableCell>
          </>
        </TableRow>
      ) : (
        //  web code
        <TableRow
          sx={{ "& > *": { borderBottom: "unset" } }}
          // style={{ cursor: "pointer" }}
        >
          <>
            <TableCell className="checkbox-row-table-inner checkbox-row-table">
              <div className="kjhgf">
                {disableOrganizationList ? (
                  <input type="checkbox" disabled />
                ) : (
                  <input
                    type="checkbox"
                    style={{ cursor: "pointer" }}
                    disabled={disableOrganizationList}
                    onChange={() => handleRowSelectList(row)}
                    checked={selectedOrganizationList?.some(
                      (i) => i.id === row?.id,
                    )}
                  />
                )}
              </div>
            </TableCell>
            <TableCell align="center">
              <h3 className="employee-size-table">
                {row?.User_favourite_list?.name
                  ? row?.User_favourite_list?.name
                  : "-"}
              </h3>
            </TableCell>
            <TableCell align="center">
              <h3 className="employee-size-table">
                {row?.User_favourite_list?.created_date
                  ? moment(row?.User_favourite_list?.created_date).format(
                      "DD MMM YYYY",
                    )
                  : "-"}
              </h3>
            </TableCell>
            <TableCell align="left">
              <div
                // onClick={() => !isDefault && handlePrivacyClick(row?.User_favourite_list?.id)}
                className="privacy-status-tr"
                // style={{
                //   color: isDefault ? "grey" : "inherit",
                //   cursor: isDefault ? "not-allowed" : "pointer",
                // }}
                style={{
                  color: "grey",
                  cursor: "not-allowed",
                }}
              >
                <h3 className="annual-revenue-table">
                  {row?.User_favourite_list?.is_private ? "Private" : "Public"}
                </h3>
                <img
                  style={{
                    color: "grey",
                    cursor: "not-allowed",
                  }}
                  // src={row?.User_favourite_list?.is_private ? privateLock : publicLock}
                  src={
                    row?.User_favourite_list?.is_private
                      ? privateLock
                      : publiclockdiabled
                  }
                  alt="My Lists"
                />
              </div>
            </TableCell>
            <TableCell align="left">
              <h3 className="employee-size-table">
                {row?.user?.first_name ? row?.user?.first_name : "-"}{" "}
                {row?.user?.last_name ? row?.user?.last_name : "-"}
              </h3>
            </TableCell>
            <TableCell align="left">
              <h3 className="employee-size-table">
                {row?.fav_people_count ? row?.fav_people_count : "-"}
              </h3>
            </TableCell>
            <TableCell>
              <TableCell align="right" className="three-dot-cell">
                {Number(row?.user?.person_id) === Number(userId) ? (
                  <span
                    className="threeDotIcon-table-profile"
                    onClick={() =>
                      !isDefault &&
                      handleOpenDeleteModal(row?.User_favourite_list?.id)
                    }
                  >
                    <img src={isDefault ? disabledelete : Delete} alt="" />
                  </span>
                ) : (
                  <span
                    className="threeDotIcon-table-profile"
                    style={{
                      color: "grey",
                      cursor: "not-allowed",
                    }}
                  >
                    <img src={disabledelete} alt="" />
                  </span>
                )}
                {Number(row?.user?.person_id) === Number(userId) ? (
                  <span
                    className="threeDotIcon-table-profile"
                    onClick={() =>
                      !isDefault &&
                      handleOpenListMdlUpdate(
                        row?.User_favourite_list?.name,
                        row?.User_favourite_list?.id,
                      )
                    }
                    style={{
                      color: isDefault ? "grey" : "",
                      cursor: isDefault ? "not-allowed" : "pointer",
                    }}
                  >
                    <DriveFileRenameOutlineIcon />
                  </span>
                ) : (
                  <span
                    className="threeDotIcon-table-profile"
                    style={{
                      color: "grey",
                      cursor: "not-allowed",
                    }}
                  >
                    <DriveFileRenameOutlineIcon />
                  </span>
                )}

                <span
                  className=""
                  // onClick={() => handleExpandRecords(row?.id)}
                >
                  <Tooltip title={open ? "Collapse" : "Expand"}>
                    {open ? (
                      <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => closeExpandHandler()}
                        className="threeDotIcon-table-profile"
                      >
                        <RemoveRoundedIcon className="icon-collapse-table" />
                      </IconButton>
                    ) : (
                      <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => {
                          setInnerDataNew([]);
                          setHasMoreInner(false);
                          setTimeout(() => {
                            if (openRowId !== row?.User_favourite_list?.id) {
                              setLoading(true);
                              setPageInner(1);
                              setopenRowId(row?.User_favourite_list?.id);
                              onExpand(row?.User_favourite_list?.id);
                            }
                          }, 0);
                        }}
                        className="threeDotIcon-table-profile"
                      >
                        <AddIcon className="icon-collapse-table" />
                      </IconButton>
                    )}
                  </Tooltip>
                </span>
              </TableCell>
            </TableCell>
          </>
        </TableRow>
      )}



{/* inner table code  */}
{/* mobile inner code  */}
      {isMobile ? (
        <>
          {" "}
          <MFavPeopleInnerTable
            openTableDrawer={openTableDrawer}
            setOpenTableDrawer={setOpenTableDrawer}
            innerDataNew={innerDataNew}
            ref={ref}
            open={open}
            disableOrganizationData={disableOrganizationData}
            setRowsSelect={setRowsSelect}
            rowsSelect={rowsSelect}
            handleRowSelect={handleRowSelect}
            selectedOrganizationData={selectedOrganizationData}
            clickHandler={clickHandler}
            IndustryDropdown={IndustryDropdown}
            pageInner={pageInner}
            pages={pages}
            loadMore={loadMore}
            organizationList={organizationList}
            loading={loading}
          />
        </>
        // tab inner code 
      ) : isTabPortrait ? (
        <>
          {" "}
          <MFavPeopleInnerTable
            openTableDrawer={openTableDrawer}
            setOpenTableDrawer={setOpenTableDrawer}
            innerDataNew={innerDataNew}
            ref={ref}
            open={open}
            disableOrganizationData={disableOrganizationData}
            setRowsSelect={setRowsSelect}
            rowsSelect={rowsSelect}
            handleRowSelect={handleRowSelect}
            selectedOrganizationData={selectedOrganizationData}
            clickHandler={clickHandler}
            IndustryDropdown={IndustryDropdown}
            pageInner={pageInner}
            pages={pages}
            loadMore={loadMore}
            organizationList={organizationList}
            loading={loading}
            isTabPortrait={isTabPortrait}
          />
        </>
        // web inner code 
      ) : innerDataNew?.length ? (
        // <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box
              sx={{ margin: 1 }}
              id="scrollableDiv"
              className="ai-leads-table-inner"
              ref={ref}
            >
              <TableContainer component={Paper} style={{ overflowX: "unset" }}>
                <Table
                  aria-label="collapsible table"
                  className="ai-leads-table"
                >
                  <TableHead>
                    <TableRow className="row-head">
                      <TableCell className="checkbox-row-table-inner checkbox-row-table">
                        <input
                          type="checkbox"
                          disabled={disableOrganizationData}
                          onChange={(e) => setRowsSelect(e?.target?.checked)}
                          checked={rowsSelect}
                        />
                      </TableCell>
                      <TableCell className="empty-name-and-title"></TableCell>
                      <TableCell className="empty-name-and-title">
                        Name & Title
                      </TableCell>
                      <TableCell className="score-row-table-New-Data">
                        JOI Strength
                      </TableCell>
                      <TableCell
                        align="left"
                        className="score-row-table-New-Data"
                      >
                        Organization
                      </TableCell>
                      <TableCell
                        align="left"
                        className="employee-row-table-innerIndustryAndSector"
                      >
                        <p className="sector-industry"> Industry/ Sector</p>
                      </TableCell>
                      <TableCell
                        align="left"
                        className="annual-row-table-NewJOSFStatus"
                      >
                        JOSF Status
                      </TableCell>
                      <TableCell
                        align="left"
                        className="industry-row-table-inner-table"
                      >
                        Contact Details
                      </TableCell>
                      <TableCell
                        align="left"
                        className="industry-row-table-inner-table"
                      ></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {innerDataNew?.some((item) => item.people_details) ? (
                      innerDataNew
                        ?.slice()
                        ?.sort((a, b) => {
                          if (a.decision_maker && !b.decision_maker) return -1;
                          if (!a.decision_maker && b.decision_maker) return 1;
                          return (
                            (b.strengthData?.strength || 0) -
                            (a.strengthData?.strength || 0)
                          );
                        })
                        ?.map((row, index) => (
                          <TableRow
                            key={index}
                            sx={{ "& > *": { borderBottom: "unset" } }}
                          >
                            <TableCell>
                              <input
                                type="checkbox"
                                disabled={disableOrganizationData}
                                onChange={() => handleRowSelect(row)}
                                checked={selectedOrganizationData.some(
                                  (item) =>
                                    item?.people_details?.person_id ===
                                    row?.people_details?.person_id,
                                )}
                              />
                            </TableCell>
                            <TableCell
                              className="Decisions-row-tableName-prospect"
                              align="left"
                            >
                              <div
                                className={
                                  row?.people_details?.decision_maker === true
                                    ? "Decision-maker-user-name"
                                    : "Decision-maker-user-noborder create-name-img"
                                }
                              >
                                <img
                                  className={
                                    row?.people_details?.suspect_status === null
                                      ? "hide-image"
                                      : "decisionMakerImageAi-Decisionmaker"
                                  }
                                  // src={decisionMakerImage}
                                  src={
                                    row?.people_details?.journey_status ===
                                    "project created"
                                      ? activeSaleforceLogo
                                      : decisionMakerImage
                                  }
                                  alt=""
                                />
                                <p className="letter-heading">
                                  {row?.people_details?.first_name
                                    ? row?.people_details?.first_name
                                        ?.split(" ")
                                        ?.find((item) => !item.includes("("))
                                        ?.charAt(0)
                                    : ""}
                                  {row?.people_details?.last_name
                                    ? row?.people_details?.last_name
                                        ?.split(" ")
                                        ?.find((item) => !item.includes("("))
                                        ?.charAt(0)
                                    : ""}
                                </p>
                              </div>
                            </TableCell>
                            <TableCell
                              className="Decision-maker-userTeblesell_row"
                              align="left"
                              onClick={() => {
                                navigate(
                                  `/Profile/${
                                    row?.people_details?.person_id == 0
                                      ? "0"
                                      : row?.people_details?.person_id
                                  }`,
                                );
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              {" "}
                              <div className="Decision-maker-user-name-main-container">
                                <div className="name-and-title-text">
                                  <div className="fullnameofuser">
                                    <h3 className="company-name-country">
                                      {row?.people_details?.first_name === "jp"
                                        ? "JP"
                                        : row?.people_details?.first_name ||
                                          "-"}
                                      &nbsp;
                                      {row?.people_details?.last_name
                                        ? row?.people_details?.last_name
                                        : "-"}
                                    </h3>
                                  </div>
                                  <div className="job-title-container">
                                    <div className="tooltip-container-jobtitle">
                                      <p
                                        className={
                                          row?.people_details?.raw_job_title
                                            ? "tooltip-highlights-jobtitle"
                                            : "tooltip-highlights-jobtitle-none"
                                        }
                                      >
                                        {row?.people_details?.raw_job_title}
                                      </p>
                                      <p className="after-company-name-country-fordecisionmaker">
                                        {row?.people_details?.primary_job_title
                                          ? row.people_details?.primary_job_title.substring(
                                              0,
                                              18,
                                            ) +
                                            (row.people_details
                                              ?.primary_job_title.length > 18
                                              ? "..."
                                              : "")
                                          : "-"}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <p className="joi-strength-control">
                                {row?.strengthData?.strength
                                  ? row?.strengthData?.strength
                                  : "-"}
                              </p>
                            </TableCell>
                            <TableCell align="left">
                              <h3 className="annual-revenue-table">
                                {row.people_details?.primary_organization
                                  ? row.people_details?.primary_organization
                                  : "-"}
                              </h3>
                            </TableCell>
                            <TableCell
                              align="left"
                              className="table-cell-of-contact-details-dropdown-th"
                            >
                              <div
                                className="Set-dropdown-ofIndustry"
                                style={{ position: "relative" }}
                              >
                                <div className="email-andrelative-other-info">
                                  <div className="maked-component-of-dropdown-forai-leads">
                                    <IndustryDropdown
                                      row={row?.people_details}
                                    />
                                  </div>
                                </div>
                              </div>
                            </TableCell>
                            <TableCell align="left">
                              <div className="Suspect-table-data">
                                <h3 className="industry-sector-table">
                                  {row?.people_details?.suspect_status
                                    ? row?.people_details?.suspect_status
                                    : "-"}
                                </h3>
                              </div>
                            </TableCell>
                            <TableCell
                              align="left"
                              className="table-cell-of-contact-details-dropdown-th-prospect"
                            >
                              <div
                                className="Set-dropdown-ofContactDetailList"
                                style={{ position: "relative" }}
                              >
                                <div className="email-and-other-infodc">
                                  <div className="maked-component-of-dropdown">
                                    <ContactDetailList
                                      item={row?.people_details}
                                    />
                                  </div>
                                </div>
                              </div>
                            </TableCell>
                            <TableCell className="table-cellhandleRightsidebar-prospect">
                              <div
                                className="table-cellhandleRightsidebar"
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <IconButton
                                  aria-label="expand row"
                                  size="small"
                                  className="button-collapse-table-propect"
                                >
                                  <RightSidebar
                                    dataShortestPath={dataShortestPath}
                                    openSidebar={openSidebar}
                                    userDetails={userDetails}
                                    handleRightsidebar={handleRightsidebar}
                                    rowid={row}
                                  />
                                </IconButton>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={7} align="center">
                          No records found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {innerDataNew?.length >= 20 ? (
                <div className="loadmore-pagination-section">
                  {pageInner <= Math.ceil(pages) && (
                    <button
                      className="btn-load-more button-loadmore-pagination"
                      onClick={loadMore}
                    >
                      {loading ? "Loading..." : "Load More"}
                    </button>
                  )}
                </div>
              ) : null}
            </Box>
          </Collapse>
        </TableCell>
      ) : // </TableRow>
      null}
    </React.Fragment>
  );
}
Row.propTypes = {
  row: PropTypes.shape({
    calories: PropTypes.number.isRequired,
    carbs: PropTypes.number.isRequired,
    fat: PropTypes.number.isRequired,
    history: PropTypes.arrayOf(
      PropTypes.shape({
        amount: PropTypes.number.isRequired,
        customerId: PropTypes.string.isRequired,
        date: PropTypes.string.isRequired,
      }),
    ).isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    protein: PropTypes.number.isRequired,
  }).isRequired,
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default function SharedPeopleList({
  loading,
  setLoading,
  selectedOuterRows,
  setSelectedOuterRows,
  showLeadsProspects,
  selectedRows,
  setSelectedRows,
  setSearchResultPeople,
  setSearchResultOrganization,
  retrieveData,
  selectedOrganizationList,
  setSelectedOrganizationList,
  selectedOrganizationData,
  setSelectedOrganizationData,
  disableOrganizationList,
  disableOrganizationData,
  innerDataNew,
  setInnerDataNew,
  openRowId,
  setopenRowId,
  activeSearchPeople,
  searchResultPeople,
  setFavoriteSearchData,
  setRetrieveData,
  handelselectdata,
  showSearchdata,
  setshowSearchdata,
  setResponseData,
  responseData,
  handleOrganizationsearch,
  headerSearchDataPeople,
  setheaderSearchDataPeople,
  handlePeoplesearch,
  isMobile,
  isTabPortrait,
}) {
  const location = useLocation();
  const [hasMoreInner, setHasMoreInner] = React.useState(false);
  const [expandHandlerAccept, setExpandHandlerAccept] = useState([]);
  const [pageInner, setPageInner] = React.useState(1);
  // const [openRowId, setopenRowId] = useState("");
  const [totalPages, setTotalPages] = useState(10);
  const prevLocationState = React.useRef(location.state);

  // favorite page code starts
  const [selectedOption, setSelectedOption] = useState("people");
  const userId = GetUserId();
  const [listName, setListName] = useState("");
  const [updatelist, setUpdatelist] = useState(false);
  const [openCreateMdl, setOpenCreateMdl] = useState(false);
  const [openCreateListmdl, setoOenCreateListmdl] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [updatedId, setUpdatedId] = useState();
  const [selectedListId, setSelectedListId] = useState(null);
  const [organizationList, setOrganizationList] = useState();

  const [rowsSelectAllList, setRowsSelectAllList] = React.useState(false);
  const [rowsSelect, setRowsSelect] = useState(false);
  const [pageInnerTwo, setPageInnerTwo] = React.useState(1);
  const [hasMoreData, setHasMoreData] = React.useState(true);

  const loadMoreTwo = () => {
    setLoading(true);
    setPageInnerTwo((prev) => prev + 1);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  const style = {
    position: "absolute",
    top: isMobile ? "22%" : "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isMobile ? 320 : 450,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "8px",
  };

  const handleOpen = () => {
    setSelectedOption("organization");
    setOpenCreateMdl(true);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };

  // get favourite list api
  const getFavList = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/favorites/list/get_share_list_people?user_id=${userId}&limit=10&skip=${
        (pageInnerTwo - 1) * 10
      }`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          const sortedData = e?.data.data.sort(
            (a, b) => (b.is_default === true) - (a.is_default === true),
          );
          const newData = e?.data?.data || [];
          setHasMoreData(newData.length > 0);

          setOrganizationList((prev) =>
            pageInnerTwo === 1 ? newData : [...prev, ...newData],
          );
          // setOrganizationList(e?.data.data);
          setSearchResultPeople(false);
          setSearchResultOrganization(false);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };
  React.useEffect(() => {
    getFavList();
  }, [pageInnerTwo]);

  // create favourite list api
  const saveOrgFavList = () => {
    if (!listName.trim()) {
      toast.error("Please Type List Name");
      return;
    }
    setLoading(true);
    const data = {
      user_id: userId,
      name: listName,
      isPrivate: true,
      type: selectedOption,
    };
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/save_favourite_list_people
`,
      data: data,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          getFavList();
          toast.success(e?.data?.message);
          setoOenCreateListmdl(false);
          setListName("");
        }
      })
      .catch((err) => {
        console.error("Error enriching prospect", err);
        setLoading(false);
      });
  };

  React.useEffect(() => {
    if (location.state !== prevLocationState.current) {
      setOrganizationList([]);
    }
    prevLocationState.current = location.state;
  }, [location.state]);

  const ExpandHandler = (event, page) => {
    setopenRowId(event);

    const option = {
      method: "POST",
      headers: {
        "content-type": "plain/text",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/get_list?id=${event}&limit=20&skip=${
        (pageInner - 1) * 20
      }`,
    };
    return axios(option).then((e) => {
      if (e?.status === 200) {
        setTotalPages(10);
        const innerdata = e?.data;
        if (innerdata?.length === 0) {
          setHasMoreInner(false);
        }
        return innerdata;
      }

      return e;
    });
  };

  const onLoadApi = async (id) => {
    setopenRowId(id);
    setLoading(true);

    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/get_list?id=${id || openRowId}&skip=0&limit=20`,
    };

    try {
      const response = await axios(option);
      setLoading(false);

      if (response?.status === 200) {
        setInnerDataNew(response.data);

        const innerdata = response.data || [];

        if (innerdata.length === 0) {
          setHasMoreInner(false);
        }
        return innerdata; // ✅ Return the data
      }
    } catch (err) {
      console.error("Error enriching prospect", err);
      setLoading(false);
      return null; // ✅ Return null or handle error case
    }
  };

  //select organization table rows
  const handleRowSelect = (row) => {
    setSelectedOrganizationData((prevSelectedRows) => {
      const isAlreadySelected = prevSelectedRows.some(
        (item) =>
          item.people_details.person_id === row.people_details.person_id,
      );

      if (isAlreadySelected) {
        return prevSelectedRows.filter(
          (item) =>
            item.people_details.person_id !== row.people_details.person_id,
        );
      } else {
        return [...prevSelectedRows, row];
      }
    });
  };
  //select organization table all rows
  React.useEffect(() => {
    if (rowsSelect) {
      const allRows = [...innerDataNew];
      setSelectedOrganizationData(allRows);
    } else if (rowsSelect === false) {
      setSelectedOrganizationData([]);
    } else if (selectedOrganizationData?.length == innerDataNew?.length) {
      setRowsSelect(true);
    } else if (selectedOrganizationData?.length < innerDataNew?.length) {
      setRowsSelect(false);
    }
  }, [rowsSelect]);

  const handleRowSelectList = (row) => {
    setSelectedOrganizationList((prevSelectedRows) => {
      const isAlreadySelected = prevSelectedRows.some(
        (item) => item.id === row.id,
      );

      if (isAlreadySelected) {
        return prevSelectedRows.filter((item) => item.id !== row.id);
      } else {
        return [...prevSelectedRows, row];
      }
    });
  };

  React.useEffect(() => {
    if (rowsSelectAllList) {
      const allRows = [...organizationList];
      setSelectedOrganizationList(allRows);
    } else if (rowsSelectAllList === false) {
      setSelectedOrganizationList([]);
    } else if (selectedOrganizationList?.length == organizationList?.length) {
      setRowsSelectAllList(true);
    } else if (selectedOrganizationList?.length < organizationList?.length) {
      setRowsSelectAllList(false);
    }
  }, [rowsSelectAllList]);

  React.useEffect(() => {
    if (retrieveData) {
      getFavList();
    }
  }, [retrieveData]);

  const handleCloseListMdl = () => {
    setoOenCreateListmdl(false);
    setListName("");
    setUpdatelist(false);
  };

  // delete list
  const deleteFavList = () => {
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APIUrlToken(),
      },
      data: [selectedListId],
      url: `${APIUrlThree()}/v1/delete_favourite_list`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          getFavList();
          toast.success(e?.data?.message);
          setOpenDeleteModal(false);
        }
      })
      .catch((err) => {
        console.error("Error enriching prospect", err);
        setLoading(false);
      });
  };

  //update list
  const updateOrgFavList = () => {
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/update_favourite_list_name?id=${updatedId}&name=${listName}`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          getFavList();
          setoOenCreateListmdl(false);
          toast.success(e?.data?.message);
        }
      })
      .catch((err) => {
        console.error("Error enriching prospect", err);
        setLoading(false);
      });
  };

  const [openSearchOne, setOpenSearchOne] = useState(false);
  // const [showSearchdata, setshowSearchdata] = React.useState(false);
  // const [headerSearchData, setheaderSearchData] = React.useState("");
  // const [responseData, setResponseData] = React.useState(null);

  const [searchTabs, setSearchTabs] = React.useState("org");
  const navigate = useNavigate();
  const emtySearchdata = () => {
    setheaderSearchDataPeople("");
  };
  React.useEffect(() => {
    const handleClick = (event) => {
      if (event.target.closest(".multi_search_header")) {
        return;
      }
      setshowSearchdata(false);
      // setheaderSearchData("");
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);
  // const handleOrganizationsearch = () => {
  //   setLoading(true);
  //   const option = {
  //     method: "POST",
  //     headers: {
  //       "access-control-allow-origin": "*",
  //       "X-API-Key": APIUrlToken(),
  //     },
  //     url: `${APIUrlThree()}/v1/search_favourites_org?search_term=${headerSearchData}&skip=0&limit=100`,
  //   };
  //   axios(option)
  //     .then((response) => {
  //       if (response.status === 200) {
  //         setLoading(false);
  //         setshowSearchdata(true);
  //         const sortedOrgData = response?.data.org?.sort((a, b) =>
  //           a.name.toLowerCase().localeCompare(b.name.toLowerCase())
  //         );
  //         setResponseData(sortedOrgData);
  //         setFavoriteSearchData(sortedOrgData);
  //         // setShowSearchdata(false)
  //       }
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       toast.error(error.response?.data?.message);
  //     });
  // };
  // const handlePeoplesearch = () => {
  //   setLoading(true);
  //   const option = {
  //     method: "POST",
  //     headers: {
  //       "access-control-allow-origin": "*",
  //       "X-API-Key": APIUrlToken(),
  //     },
  //     url: `${APIUrlThree()}/v1/search_favourites_people?search_term=${headerSearchData}&skip=0&limit=100`,
  //   };
  //   axios(option)
  //     .then((response) => {
  //       if (response.status === 200) {
  //         setLoading(false);
  //         setshowSearchdata(true);
  //         const sortedOrgData = response?.data?.people.sort((a, b) =>
  //           a.first_name.toLowerCase().localeCompare(b.first_name.toLowerCase())
  //         );
  //         setResponseData(sortedOrgData);
  //         setFavoriteSearchData(sortedOrgData);
  //       }
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       toast.error(error.response?.data?.message);
  //     });
  // };
  React.useEffect(() => {
    let timer;
    if (headerSearchDataPeople?.length > 1) {
      timer = setTimeout(() => {
        if (activeSearchPeople === "people") {
          handlePeoplesearch();
        } else {
          handleOrganizationsearch();
        }
      }, 1000);
    }
    return () => clearTimeout(timer);
  }, [headerSearchDataPeople, activeSearchPeople]);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      setshowSearchdata(false);
      if (activeSearchPeople === "organization") {
        setSearchResultPeople(false);
        setSearchResultOrganization(true);
      } else if (activeSearchPeople === "people") {
        setSearchResultPeople(true);
        setSearchResultOrganization(false);
      } else {
        setSearchResultPeople(false);
        setSearchResultOrganization(false);
      }
    }
  };
  // const handelselectdata = (item) => {
  //   setheaderSearchData(item?.name);
  //   if (searchTabs === "org") {
  //     navigate(`/companyprofilescreen/${item?.org_id}/0`, {
  //       state: {
  //         isComponyScreen: window.location.pathname.includes(
  //           "companyprofilescreen"
  //         ),
  //       },
  //     });
  //   } else {
  //     navigate(`/Profile/${item?.person_id == 0 ? "0" : item?.person_id}`);
  //   }
  // };
  const handleOnchange = (e) => {
    const inputValue = e.target.value;
    setheaderSearchDataPeople(inputValue);
    if (e.target.value == "") {
      setRetrieveData(true);
    }
  };
  React.useEffect(() => {
    if (
      organizationList?.length >= 10 &&
      pageInnerTwo > 1 &&
      pageInnerTwo <= Math.ceil(pagesTwo)
    ) {
      // setHasMoreInner(false);
      // ExpandHandlerChild(openRowId);
    }
  }, [pageInnerTwo]);

  const pagesTwo = organizationList?.fav_leads_count / 10;

  return (
    <React.Fragment>
      {isMobile ? (
        organizationList?.length ? (
          <>
            <TableContainer component={Paper} className="ai-leads-table-main">
              <Table aria-label="collapsible table" className="ai-leads-table">
                <TableBody>
                  {organizationList?.map((row, index) => {
                    const isSelected = selectedRows?.find(
                      (item) => item?.person_id === row?.person_id,
                    );
                    return (
                      <React.Fragment key={index}>
                        <Row
                          key={row.name}
                          row={row}
                          selected={isSelected}
                          onSelect={(selectedRow) => {
                            const localRows = [...selectedRows];
                            const selectedIndex = localRows.findIndex(
                              (row) =>
                                row?.person_id === selectedRow?.person_id,
                            );
                            let newSelected = [];
                            if (selectedIndex === -1) {
                              newSelected = [selectedRow];
                            } else if (selectedIndex === 0) {
                              newSelected = newSelected.concat(
                                localRows.slice(1),
                              );
                            } else if (selectedIndex === localRows.length - 1) {
                              newSelected = newSelected.concat(
                                localRows.slice(0, -1),
                              );
                            } else if (selectedIndex > 0) {
                              newSelected = localRows.filter(
                                (child) =>
                                  child.person_id !== selectedRow.person_id,
                              );
                            }
                            const updatedOrganizations = newSelected.map(
                              (name) => {
                                const organization = organizationList.find(
                                  (org) => org?.org_id === name?.org_id,
                                );
                                return {
                                  ...name,
                                  organizationInfo: organization,
                                };
                              },
                            );
                            setSelectedRows(
                              selectedIndex > -1
                                ? updatedOrganizations
                                : [...selectedRows, ...updatedOrganizations],
                            );
                          }}
                          connectionStrength={row.connectionStrength}
                          ExpandHandler={ExpandHandler}
                          onLoadApi={onLoadApi}
                          expandHandlerAccept={expandHandlerAccept}
                          selectedRows={selectedRows}
                          setSelectedRows={setSelectedRows}
                          setPageInner={setPageInner}
                          pageInner={pageInner}
                          openRowId={openRowId}
                          hasMoreInner={hasMoreInner}
                          setExpandHandlerAccept={setExpandHandlerAccept}
                          setopenRowId={setopenRowId}
                          setHasMoreInner={setHasMoreInner}
                          totalPages={totalPages}
                          selectedOuterRows={selectedOuterRows}
                          setSelectedOuterRows={setSelectedOuterRows}
                          organizationList={organizationList}
                          setOrganizationList={setOrganizationList}
                          handleRowSelect={handleRowSelect}
                          showLeadsProspects={showLeadsProspects}
                          setoOenCreateListmdl={setoOenCreateListmdl}
                          setOpenCreateMdl={setOpenCreateMdl}
                          setSelectedOption={setSelectedOption}
                          selectedOption={selectedOption}
                          setListName={setListName}
                          setUpdatelist={setUpdatelist}
                          setUpdatedId={setUpdatedId}
                          setSelectedListId={setSelectedListId}
                          listName={listName}
                          setOpenDeleteModal={setOpenDeleteModal}
                          updatedId={updatedId}
                          selectedListId={selectedListId}
                          innerDataNew={innerDataNew}
                          setInnerDataNew={setInnerDataNew}
                          handleRowSelectList={handleRowSelectList}
                          rowsSelect={rowsSelect}
                          setRowsSelect={setRowsSelect}
                          selectedOrganizationList={selectedOrganizationList}
                          selectedOrganizationData={selectedOrganizationData}
                          setSelectedOrganizationData={
                            setSelectedOrganizationData
                          }
                          disableOrganizationList={disableOrganizationList}
                          disableOrganizationData={disableOrganizationData}
                          userId={userId}
                          isMobile={isMobile}
                        />
                      </React.Fragment>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            {organizationList.length >= 10 && hasMoreData ? (
              <div className="loadmore-pagination-section">
                <button
                  className="btn-load-more button-loadmore-pagination"
                  onClick={loadMoreTwo}
                >
                  {loading ? "Loading..." : "Load More"}
                </button>
              </div>
            ) : null}
          </>
        ) : (
          <div className="ai-leads-table-main">
            <div className="ai-leads-no-data-available-outter">
              <div className="ai-leads-no-data-available">
                No Data Available
              </div>
            </div>
          </div>
        )
      ) : isTabPortrait ? (
        organizationList?.length ? (
          <>
            <TableContainer component={Paper} className="ai-leads-table-main">
              <Table aria-label="collapsible table" className="ai-leads-table">
                <TableBody>
                  {organizationList?.map((row, index) => {
                    const isSelected = selectedRows?.find(
                      (item) => item?.person_id === row?.person_id,
                    );
                    return (
                      <React.Fragment key={index}>
                        <Row
                          key={row.name}
                          row={row}
                          selected={isSelected}
                          onSelect={(selectedRow) => {
                            const localRows = [...selectedRows];
                            const selectedIndex = localRows.findIndex(
                              (row) =>
                                row?.person_id === selectedRow?.person_id,
                            );
                            let newSelected = [];
                            if (selectedIndex === -1) {
                              newSelected = [selectedRow];
                            } else if (selectedIndex === 0) {
                              newSelected = newSelected.concat(
                                localRows.slice(1),
                              );
                            } else if (selectedIndex === localRows.length - 1) {
                              newSelected = newSelected.concat(
                                localRows.slice(0, -1),
                              );
                            } else if (selectedIndex > 0) {
                              newSelected = localRows.filter(
                                (child) =>
                                  child.person_id !== selectedRow.person_id,
                              );
                            }
                            const updatedOrganizations = newSelected.map(
                              (name) => {
                                const organization = organizationList.find(
                                  (org) => org?.org_id === name?.org_id,
                                );
                                return {
                                  ...name,
                                  organizationInfo: organization,
                                };
                              },
                            );
                            setSelectedRows(
                              selectedIndex > -1
                                ? updatedOrganizations
                                : [...selectedRows, ...updatedOrganizations],
                            );
                          }}
                          connectionStrength={row.connectionStrength}
                          ExpandHandler={ExpandHandler}
                          onLoadApi={onLoadApi}
                          expandHandlerAccept={expandHandlerAccept}
                          selectedRows={selectedRows}
                          setSelectedRows={setSelectedRows}
                          setPageInner={setPageInner}
                          pageInner={pageInner}
                          openRowId={openRowId}
                          hasMoreInner={hasMoreInner}
                          setExpandHandlerAccept={setExpandHandlerAccept}
                          setopenRowId={setopenRowId}
                          setHasMoreInner={setHasMoreInner}
                          totalPages={totalPages}
                          selectedOuterRows={selectedOuterRows}
                          setSelectedOuterRows={setSelectedOuterRows}
                          organizationList={organizationList}
                          setOrganizationList={setOrganizationList}
                          handleRowSelect={handleRowSelect}
                          showLeadsProspects={showLeadsProspects}
                          setoOenCreateListmdl={setoOenCreateListmdl}
                          setOpenCreateMdl={setOpenCreateMdl}
                          setSelectedOption={setSelectedOption}
                          selectedOption={selectedOption}
                          setListName={setListName}
                          setUpdatelist={setUpdatelist}
                          setUpdatedId={setUpdatedId}
                          setSelectedListId={setSelectedListId}
                          listName={listName}
                          setOpenDeleteModal={setOpenDeleteModal}
                          updatedId={updatedId}
                          selectedListId={selectedListId}
                          innerDataNew={innerDataNew}
                          setInnerDataNew={setInnerDataNew}
                          handleRowSelectList={handleRowSelectList}
                          rowsSelect={rowsSelect}
                          setRowsSelect={setRowsSelect}
                          selectedOrganizationList={selectedOrganizationList}
                          selectedOrganizationData={selectedOrganizationData}
                          setSelectedOrganizationData={
                            setSelectedOrganizationData
                          }
                          disableOrganizationList={disableOrganizationList}
                          disableOrganizationData={disableOrganizationData}
                          userId={userId}
                          isMobile={isMobile}
                          isTabPortrait={isTabPortrait}
                        />
                      </React.Fragment>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            {organizationList.length >= 10 && hasMoreData ? (
              <div className="loadmore-pagination-section">
                <button
                  className="btn-load-more button-loadmore-pagination"
                  onClick={loadMoreTwo}
                >
                  {loading ? "Loading..." : "Load More"}
                </button>
              </div>
            ) : null}
          </>
        ) : (
          <div className="ai-leads-table-main">
            <div className="ai-leads-no-data-available-outter">
              <div className="ai-leads-no-data-available">
                No Data Available
              </div>
            </div>
          </div>
        )
      ) : organizationList?.length ? (
        <>
          <TableContainer component={Paper} className="ai-leads-table-main">
            <Table aria-label="collapsible table" className="ai-leads-table">
              <TableHead>
                <TableRow className="table-row-ai-leads-favlist">
                  <TableCell className="checkbox-row-table-inner checkbox-row-table">
                    <div className="kjhgf">
                      <input
                        type="checkbox"
                        style={{ cursor: "pointer" }}
                        disabled={disableOrganizationList}
                        onChange={(e) =>
                          setRowsSelectAllList(e?.target?.checked)
                        }
                        checked={rowsSelectAllList}
                      />
                    </div>
                  </TableCell>
                  <TableCell align="left" className="company-row-table-favlist">
                    List Name
                  </TableCell>
                  <TableCell align="left" className="company-row-table-favlist">
                    Date Created
                  </TableCell>
                  <TableCell align="left" className="company-row-table-favlist">
                    Privacy Status
                  </TableCell>
                  <TableCell align="left" className="company-row-table-favlist">
                    List Owner
                  </TableCell>
                  <TableCell
                    align="left"
                    className="company-row-table-favlist-create"
                  >
                    <div className="search_news_container-inner">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          position: "relative",
                        }}
                      >
                        {openSearchOne ? (
                          <Paper
                            className={
                              openSearchOne
                                ? "input_search_news-inner active"
                                : "input_search_news-inner"
                            }
                          >
                            <InputBase
                              value={headerSearchDataPeople}
                              onChange={(e) => {
                                handleOnchange(e);
                              }}
                              className="fav-type-input-inner"
                              onKeyDown={handleKeyDown}
                              sx={{ ml: 1, flex: 1 }}
                              placeholder="Search..."
                              inputProps={{
                                "aria-label": "Search google maps",
                              }}
                              autoComplete="off"
                            />
                            <div
                              onClick={emtySearchdata}
                              className="cross-icon-prospect-search"
                            ></div>{" "}
                            {showSearchdata && (
                              <div
                                className={
                                  window.location.pathname ===
                                    COMPANY_PROFILE_SCREEN ||
                                  window.location.pathname ===
                                    AI_PROFILE_FORM_TABLE ||
                                  window.location.pathname ===
                                    AI_PROSPECT_PROFILE
                                    ? "NewClassNamepathname"
                                    : "Autocompletedropdown-fav-inner"
                                }
                              >
                                {responseData?.length > 0 ? (
                                  responseData.map((item, index) => (
                                    <>
                                      {item?.id === null ? (
                                        <div
                                          className="outterAutocompletedropdown2"
                                          key={`heading-${index}`}
                                        >
                                          <div className="useralldata">
                                            <strong>
                                              {searchResultPeople
                                                ? item?.first_name
                                                : item?.name}
                                            </strong>
                                          </div>
                                          <div className="separatorline"></div>
                                        </div>
                                      ) : (
                                        <div
                                          className="outterAutocompletedropdown"
                                          key={item.id || `data-${index}`}
                                        >
                                          <div
                                            onClick={() =>
                                              handelselectdata(item)
                                            }
                                            className="useralldata-inner"
                                          >
                                            {[
                                              searchResultPeople
                                                ? item?.name
                                                : item?.name?.toLowerCase() ===
                                                    "jp nauseef"
                                                  ? "JP Nauseef"
                                                  : item?.name
                                                      ?.split(" ")
                                                      .map(
                                                        (word) =>
                                                          word
                                                            .charAt(0)
                                                            .toUpperCase() +
                                                          word
                                                            .slice(1)
                                                            .toLowerCase(),
                                                      )
                                                      .join(" "),
                                              item?.categories
                                                ?.split(" ")
                                                .map(
                                                  (word) =>
                                                    word
                                                      .charAt(0)
                                                      .toUpperCase() +
                                                    word.slice(1).toLowerCase(),
                                                )
                                                .join(" "),
                                              item?.primary_organization
                                                ?.split(" ")
                                                .map(
                                                  (word) =>
                                                    word
                                                      .charAt(0)
                                                      .toUpperCase() +
                                                    word.slice(1).toLowerCase(),
                                                )
                                                .join(" "),
                                              item?.linkedin,
                                            ]
                                              .filter(Boolean)
                                              .join(", ")}
                                          </div>
                                          <div className="separatorline"></div>
                                        </div>
                                      )}
                                    </>
                                  ))
                                ) : (
                                  <div className="useralldata">
                                    Not Available
                                  </div>
                                )}
                              </div>
                            )}
                            <CloseIcon
                              className="threedot-icon-comp-inner"
                              onClick={() => {
                                setOpenSearchOne(false);
                              }}
                            />
                          </Paper>
                        ) : null}
                        <Paper>
                          {openSearchOne ? (
                            ""
                          ) : (
                            <img
                              className="image-seacrh-fav-inner"
                              src={redSearchicon}
                              alt=""
                              onClick={() => {
                                setOpenSearchOne(true);
                              }}
                            />
                          )}
                        </Paper>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell align="left" className="company-row-table-favlist">
                    {/* <div className="createlist-text-img-table" onClick={handleOpen}><p>
                      Create a New List </p><img src={createfolderlogo} alt="" />
                    </div>  */}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {organizationList?.map((row, index) => {
                  const isSelected = selectedRows?.find(
                    (item) => item?.person_id === row?.person_id,
                  );
                  return (
                    <React.Fragment key={index}>
                      <Row
                        key={row.name}
                        row={row}
                        selected={isSelected}
                        onSelect={(selectedRow) => {
                          const localRows = [...selectedRows];
                          const selectedIndex = localRows.findIndex(
                            (row) => row?.person_id === selectedRow?.person_id,
                          );
                          let newSelected = [];
                          if (selectedIndex === -1) {
                            newSelected = [selectedRow];
                          } else if (selectedIndex === 0) {
                            newSelected = newSelected.concat(
                              localRows.slice(1),
                            );
                          } else if (selectedIndex === localRows.length - 1) {
                            newSelected = newSelected.concat(
                              localRows.slice(0, -1),
                            );
                          } else if (selectedIndex > 0) {
                            newSelected = localRows.filter(
                              (child) =>
                                child.person_id !== selectedRow.person_id,
                            );
                          }
                          const updatedOrganizations = newSelected.map(
                            (name) => {
                              const organization = organizationList.find(
                                (org) => org?.org_id === name?.org_id,
                              );
                              return {
                                ...name,
                                organizationInfo: organization,
                              };
                            },
                          );
                          setSelectedRows(
                            selectedIndex > -1
                              ? updatedOrganizations
                              : [...selectedRows, ...updatedOrganizations],
                          );
                        }}
                        connectionStrength={row.connectionStrength}
                        ExpandHandler={ExpandHandler}
                        onLoadApi={onLoadApi}
                        expandHandlerAccept={expandHandlerAccept}
                        selectedRows={selectedRows}
                        setSelectedRows={setSelectedRows}
                        setPageInner={setPageInner}
                        pageInner={pageInner}
                        openRowId={openRowId}
                        hasMoreInner={hasMoreInner}
                        setExpandHandlerAccept={setExpandHandlerAccept}
                        setopenRowId={setopenRowId}
                        setHasMoreInner={setHasMoreInner}
                        totalPages={totalPages}
                        selectedOuterRows={selectedOuterRows}
                        setSelectedOuterRows={setSelectedOuterRows}
                        organizationList={organizationList}
                        setOrganizationList={setOrganizationList}
                        handleRowSelect={handleRowSelect}
                        showLeadsProspects={showLeadsProspects}
                        setoOenCreateListmdl={setoOenCreateListmdl}
                        setOpenCreateMdl={setOpenCreateMdl}
                        setSelectedOption={setSelectedOption}
                        selectedOption={selectedOption}
                        setListName={setListName}
                        setUpdatelist={setUpdatelist}
                        setUpdatedId={setUpdatedId}
                        setSelectedListId={setSelectedListId}
                        listName={listName}
                        setOpenDeleteModal={setOpenDeleteModal}
                        updatedId={updatedId}
                        selectedListId={selectedListId}
                        innerDataNew={innerDataNew}
                        setInnerDataNew={setInnerDataNew}
                        handleRowSelectList={handleRowSelectList}
                        rowsSelect={rowsSelect}
                        setRowsSelect={setRowsSelect}
                        selectedOrganizationList={selectedOrganizationList}
                        selectedOrganizationData={selectedOrganizationData}
                        setSelectedOrganizationData={
                          setSelectedOrganizationData
                        }
                        disableOrganizationList={disableOrganizationList}
                        disableOrganizationData={disableOrganizationData}
                        userId={userId}
                      />
                    </React.Fragment>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          {organizationList.length >= 10 && hasMoreData ? (
            <div className="loadmore-pagination-section">
              <button
                className="btn-load-more button-loadmore-pagination"
                onClick={loadMoreTwo}
              >
                {loading ? "Loading..." : "Load More"}
              </button>
            </div>
          ) : null}
        </>
      ) : (
        <div className="ai-leads-table-main">
          <div className="ai-leads-no-data-available-outter">
            <div className="ai-leads-no-data-available">No Data Available</div>
          </div>
        </div>
      )}
      <Modal
        open={openCreateListmdl}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="vrufyerv">
          <Box sx={style} style={{ overflowY: "auto" }}>
            <h3 className="type-of-list-fav">
              Name Your List{" "}
              <ClearIcon
                onClick={handleCloseListMdl}
                style={{ cursor: "pointer" }}
              />
            </h3>
            <div className="type-of-list-fav-body">
              <div className="input-list-fav-create">
                <label htmlFor="">List Name</label>
                <input
                  type="text"
                  onChange={(e) => setListName(e.target.value)}
                  value={listName}
                />
              </div>
              <div className="de_hr">
                <div className="de_btn_cont">
                  <Button className="de_cancel" onClick={handleCloseListMdl}>
                    Cancel
                  </Button>
                  <Button
                    className="de_next"
                    onClick={updatelist ? updateOrgFavList : saveOrgFavList}
                    style={{ cursor: "pointer" }}
                  >
                    {updatelist ? "Update" : "Submit"}
                  </Button>
                </div>
              </div>
            </div>
          </Box>
        </div>
      </Modal>

      <Modal
        open={openDeleteModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="vrufyerv">
          <Box sx={style} style={{ overflowY: "auto" }}>
            <h3 className="type-of-list-fav">
              Are you sure you want to delete this record?
              <ClearIcon
                onClick={handleCloseDeleteModal}
                style={{ cursor: "pointer" }}
              />
            </h3>
            <div className="type-of-list-fav-body">
              <div className="de_hr">
                <div className="de_btn_cont">
                  <Button
                    className="de_cancel"
                    onClick={handleCloseDeleteModal}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="de_next"
                    style={{ cursor: "pointer" }}
                    onClick={deleteFavList}
                  >
                    Delete
                  </Button>
                </div>
              </div>
            </div>
          </Box>
        </div>
      </Modal>
    </React.Fragment>
  );
}
